import React from "react";
import SaveIcon from "../Icons/SaveIcon";

const SaveButton = ({
  isSaving,
  designVersion,
  savedVersion,
  onSaveDesign,
}) => {
  let saveText = "",
    savedStatus = "unsaved";

  if (isSaving) {
    saveText = "Saving...";
    savedStatus = "saving";
  } else if (designVersion === savedVersion) {
    saveText = "Saved!";
    savedStatus = "saved";
  } else {
    saveText = "Save";
    savedStatus = "unsaved";
  }

  return (
    <li
      className={`navigation__item navigation__item--extra navigation__item--save ${savedStatus}`}
      onClick={onSaveDesign}
    >
      <div className="navigation__icon">
        <SaveIcon />
      </div>
      <span className="navigation__action__text">{saveText}</span>
    </li>
  );
};

export default SaveButton;
